export default "/assets/080091e87ac84bcb.svg"